import styled, { css } from 'styled-components'
import { colors, derivedColors } from '../../const'

const getButtonColor = (type) => {
  if (type === 'primary') return colors.surface
  if (type === 'secondary') return colors.primary
  return colors.primary
}

const getButtonBackground = (type) => {
  if (type === 'primary') return colors.primary
  if (type === 'secondary') return derivedColors.transparentSecondary
  return colors.surface
}

export const Container = styled.div`
  background-color: ${colors.surface};
  box-shadow:
    0px 0px 1px rgba(0, 0, 0, 0.06),
    0px 0px 2px rgba(0, 0, 0, 0.04),
    0px 0px 5px rgba(0, 0, 0, 0.04),
    0px 0px 17px rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  font-family: 'Inter';
  padding: 2%;
  width: 45%;
`

export const Title = styled.h1`
  color: ${colors.textSecondary};
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
`

export const ParametersWrapper = styled.div`
  display: grid;
  font-family: 'Inter';
  gap: 14px 4px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  margin-top: 16px;
  width: 100%;
`

export const ParametersCell = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;
  width: 100%;
`

export const ParameterTitle = styled.p`
  color: ${colors.textPrimary};
  font-size: 0.75rem;
  margin: 0;
`

export const ParameterDescription = styled.p`
  color: ${colors.primary};
  font-size: 0.875rem;
  margin: 0;
`

export const LabelAndDescriptionWrapper = styled.div`
  font-family: 'Inter';
  display: grid;
  grid-template-columns: 1fr;
  margin-top: 20px;
`

export const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 700;
  margin-top: 16px;
  text-transform: uppercase;
  width: 100%;
`

export const Description = styled.div`
  display: grid;
  font-size: 0.75rem;
  gap: 12px;
  grid-template-columns: 1fr;
  margin-top: 6px;
  width: 100%;
`

export const SignatureWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

export const Signature = styled.img``

export const DigitalSignatureWrapper = styled.div`
  color: ${derivedColors.attenuated};
  display: flex;
  gap: 8px;
  flex-direction: column;
  font-family: 'Inter';
  width: 100%;
`

export const DigitalSignatureTitle = styled.p`
  font-size: 0.5rem;
  margin: 0;
  text-transform: uppercase;
`

export const DigitalSignatureValue = styled.p`
  font-size: 0.625rem;
  margin: 0;
  word-break: break-all;
`
export const ButtonsWrapper = styled.footer`
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: flex-end;
  margin-bottom: 10px;
  margin-top: auto;
  width: 100%;
`

export const Button = styled.button(
  ({ type }) => css`
    align-items: center;
    background-color: ${getButtonBackground(type)};
    border: none;
    border-radius: 6px;
    color: ${getButtonColor(type)};
    cursor: pointer;
    display: flex;
    font-family: 'Inter';
    font-size: 0.875rem;
    font-weight: 500;
    gap: 6px;
    height: 40px;
    justify-content: center;
    margin-top: 20px;
    min-width: 112px;
    padding: 0 12px;
  `
)

export const ButtonIcon = styled.img``
